import { useState, useEffect } from 'react';
import { captureException } from '@sentry/react';
import { ApiService } from '../../API/AxiosInstance';

const OnboardingStatusHook = (url) => {
  const [onboardingStatusText, setData] = useState(null); 
  const [apiLoading, setLoading] = useState(true); 
  const [error, setError] = useState(null); 

  useEffect(() => {
    const fetchData = async ( ) => {
      try {
        setLoading(true);
        const response = await ApiService().get(url)
        if(response?.status == 200) {
          const finalStatus = Object.values(response?.data?.status).every(item => item)
          setData(finalStatus)
        } 
      } catch (err) {
        setError(err);
        captureException(err)
      } finally {
        setLoading(false);
      }
    };

    fetchData();
  }, [url]);

  return { onboardingStatusText, apiLoading, error };
};

export default OnboardingStatusHook;
